import React, { FC, Fragment, useEffect, useState } from 'react';
import {
    Card,
    Form as AntForm,
    Descriptions,
    Alert,
    Rate,
    Spin,
    Button,
    Empty,
    Icon,
    Modal,
} from 'antd';
import { Image } from '@comall-backend-builder/components-basis';
import { FormComponentProps } from 'antd/es/form';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { services } from '@comall-backend-builder/core';
import DetailTitle from '../DetailTitle';
import DisplayStatus from '../DisplayStatus';
import { errorHandle } from '../../services';
import { isArray } from 'lodash';
import '../sunbathing-edit/index.less';

const api = services.api;

export interface CategoryFilterAttrTableProps {
    entity: Entity;
    params: any;
    componentId: string;
    form: FormComponentProps['form'];
}
export const SunbathingDetailDom: FC = (props: any) => {
    const params = props.params || {};
    const id = params.id || '';
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState<any>({});
    const [reply, setReply] = useState<any>({ result: [], hideCount: '', showCount: '' });
    const [showPreview, setShowPreview] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const ImageProps = {
        text: '品真阁',
        style: {
            width: '150px',
        },
    };

    // 获取详情信息
    const handlleGetDetail = () => {
        setLoading(true);
        api.get({}, { apiPath: `/review_list/detail/${id}` })
            .then((res: any) => {
                setDetail(res);
            })
            .catch(errorHandle)
            .finally(() => {
                setLoading(false);
            });
    };

    // 获取详情信息
    const handlleGetReply = () => {
        api.get({ page: 1, perPage: 1000 }, { apiPath: `/review_list/reply/${id}` })
            .then((res: any) => {
                setReply(res);
            })
            .catch(errorHandle);
    };

    useEffect(() => {
        handlleGetDetail();
        handlleGetReply();
        return () => {
            sessionStorage.setItem('fromSunbathingOrder', 'true');
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const goBack = () => {
        services.navigation.goto('/content/sunbathingOrder');
    };

    const handlePreview = (item: any) => {
        setPreviewImage(item);
        setShowPreview(true);
    };

    return (
        <Fragment>
            <Spin spinning={loading}>
                <div className="sunbathing-edit-dom">
                    <Card title="基本信息" extra={<Button onClick={goBack}>返回</Button>}>
                        <DetailTitle label={'基本信息'} />
                        <Descriptions>
                            <Descriptions.Item label="显示状态">
                                {detail.showStatus === 0 ? '显示' : '隐藏'}
                            </Descriptions.Item>
                            <Descriptions.Item label="排序">
                                {detail.sortValue ?? '--'}
                            </Descriptions.Item>
                            <Descriptions.Item label="是否追评">
                                {detail.secondaryStatus === 1 ? '已追评' : '未追评'}
                            </Descriptions.Item>
                            <Descriptions.Item label="会员账户">
                                {detail.loginName || '--'}
                            </Descriptions.Item>
                            {/* <Descriptions.Item label="微信昵称">{'--'}</Descriptions.Item> */}
                            <Descriptions.Item label="会员等级">
                                {detail.memberLevelName ?? '--'}
                            </Descriptions.Item>
                            <Descriptions.Item label="评价sku">
                                {detail.skuCode || '--'}
                            </Descriptions.Item>
                            <Descriptions.Item label="商品款号">
                                {detail.styleCode || '--'}
                            </Descriptions.Item>
                            <Descriptions.Item label="商品名称">
                                {detail.skuName || '--'}
                            </Descriptions.Item>
                            <Descriptions.Item label="评分">
                                <Rate disabled value={detail.star} />
                            </Descriptions.Item>
                            <Descriptions.Item label="获得点赞">
                                <Icon type="heart" style={{ marginRight: '4px' }} />
                                {detail.praiseCount ?? '--'}
                            </Descriptions.Item>
                        </Descriptions>
                        <DetailTitle label={'晒单内容'} />
                        <Card>
                            <Descriptions>
                                <Descriptions.Item className="time-style" label="发布时间">
                                    {detail.createTimeStr || '--'}
                                </Descriptions.Item>
                            </Descriptions>
                            <div style={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}>
                                {detail.content ? detail.content.replace(/ /g, '\u00a0') : '--'}
                            </div>
                            {detail.picList && isArray(detail.picList) && (
                                <div>
                                    {detail.picList.map((item: any, index: React.Key) => (
                                        <div
                                            key={index}
                                            className="image-box"
                                            onClick={() => handlePreview(item)}
                                        >
                                            <Image imageurl={item!} {...ImageProps} />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Card>

                        {Number(detail.secondaryStatus) === 1 && (
                            <Card style={{ margin: '20px 0' }}>
                                <div className="alert-box">
                                    <Alert
                                        message={`${detail.secondaryInterval}天后追评`}
                                        type="info"
                                        style={{
                                            width: '120px',
                                            textAlign: 'center',
                                            marginBottom: '8px',
                                        }}
                                    />
                                    <DisplayStatus
                                        displayStatus={detail.secondaryShowStatus === 0}
                                    />
                                </div>

                                <Descriptions>
                                    <Descriptions.Item className="time-style" label="追评时间">
                                        {detail.secondaryReviewTimeStr || '--'}
                                    </Descriptions.Item>
                                </Descriptions>
                                <div style={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}>
                                    {detail.secondaryContent
                                        ? detail.secondaryContent.replace(/ /g, '\u00a0')
                                        : '--'}
                                </div>
                                {detail.secondaryPicList && isArray(detail.secondaryPicList) ? (
                                    <div>
                                        {detail.secondaryPicList.map(
                                            (item: any, index: React.Key) => (
                                                <div
                                                    key={index}
                                                    className="image-box"
                                                    onClick={() => handlePreview(item)}
                                                >
                                                    <Image imageurl={item!} {...ImageProps} />
                                                </div>
                                            )
                                        )}
                                    </div>
                                ) : null}
                            </Card>
                        )}

                        <DetailTitle
                            label={'评论记录'}
                            dic={` 显示 ${reply.showCount ?? '0'} 条，隐藏 ${reply.hideCount ??
                                '0'} 条`}
                        />
                        {isArray(reply.result) && reply.result.length ? (
                            <div>
                                {reply.result.map((item: any) => (
                                    <div className="comment-item" key={item.id}>
                                        <div className="user-content">
                                            <div className="user-info">
                                                <div className="name">{item.loginName}</div>
                                                <div className="time">{item.replyTimeStr}</div>
                                            </div>
                                            <div>{item.replyContent}</div>
                                        </div>
                                        <DisplayStatus displayStatus={item.replyStatus === 0} />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        )}
                    </Card>
                </div>

                <Modal
                    visible={showPreview}
                    footer={null}
                    width={500}
                    style={{ textAlign: 'center' }}
                    onCancel={() => {
                        setShowPreview(false);
                        setTimeout(() => {
                            setPreviewImage('');
                        }, 20);
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        <img style={{ width: '100%' }} src={previewImage} alt="" />
                    </div>
                </Modal>
            </Spin>
        </Fragment>
    );
};

export const SunbathingDetail = AntForm.create<CategoryFilterAttrTableProps>()(SunbathingDetailDom);
